import React from 'react';

function EmailSvg() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path opacity="0.2" d="M35 8.75L20 22.5L5 8.75H35Z" fill="#1B1B18" />
      <path d="M35 7.5H5C4.66848 7.5 4.35054 7.6317 4.11612 7.86612C3.8817 8.10054 3.75 8.41848 3.75 8.75V30C3.75 30.663 4.01339 31.2989 4.48223 31.7678C4.95107 32.2366 5.58696 32.5 6.25 32.5H33.75C34.413 32.5 35.0489 32.2366 35.5178 31.7678C35.9866 31.2989 36.25 30.663 36.25 30V8.75C36.25 8.41848 36.1183 8.10054 35.8839 7.86612C35.6495 7.6317 35.3315 7.5 35 7.5ZM20 20.8047L8.21406 10H31.7859L20 20.8047ZM15.4234 20L6.25 28.4078V11.5922L15.4234 20ZM17.2734 21.6953L19.1484 23.4219C19.3791 23.6336 19.6807 23.751 19.9937 23.751C20.3068 23.751 20.6084 23.6336 20.8391 23.4219L22.7141 21.6953L31.7766 30H8.21406L17.2734 21.6953ZM24.5766 20L33.75 11.5906V28.4094L24.5766 20Z" fill="#1B1B18" />
    </svg>
  );
}

export default EmailSvg;
